import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import styles from './Layout.module.scss';
export const Box = (_0)=>{
    let { className, children, gap, alignItems, justifyContent, padding, width, height, wrap, style, as, testId, inline } = _0, rest = _object_without_properties(_0, [
        "className",
        "children",
        "gap",
        "alignItems",
        "justifyContent",
        "padding",
        "width",
        "height",
        "wrap",
        "style",
        "as",
        "testId",
        "inline"
    ]);
    const Component = as || 'div';
    return /*#__PURE__*/ _jsx(Component, _object_spread_props(_object_spread({
        className: cn(inline ? styles.inlineBox : styles.box, className),
        "data-testid": testId
    }, rest), {
        style: _object_spread({
            gap,
            alignItems,
            justifyContent,
            padding,
            width,
            height,
            flexWrap: wrap ? 'wrap' : 'nowrap'
        }, style),
        children: children
    }));
};
